import { jnjInfo } from "@jmc/solid-design-system/src/components/atoms/Icon/Icon";
import { SnackBar } from "@jmc/solid-design-system/src/components/atoms/SnackBar/SnackBar";
import { Typography } from "@jmc/solid-design-system/src/components/atoms/Typography/Typography";
import { useJnjBranding } from "@jmc/utils/hooks/useJnjBranding";
import { mdiInformationOutline } from "@mdi/js";
import React from "react";

import style from "./style.module.scss";

interface PropTypes {
    textMsg: string;
}

/**
 * Presentation component rendering a text message inside snackbar for the action.
 */
export const SnackbarErrorMsg: React.FunctionComponent<PropTypes> = ({ textMsg }: PropTypes) => {
    const { jnjFullBranded } = useJnjBranding();

    return (
        <div className={style.paddingSnackbar}>
            <Typography>
                <SnackBar color={jnjFullBranded ? "white" : "primary"}>
                    <SnackBar.Icon
                        icon={jnjFullBranded ? jnjInfo : mdiInformationOutline}
                        color={jnjFullBranded ? "interactive-07" : "inherit"}
                    />
                    <SnackBar.Text text={textMsg} />
                </SnackBar>
            </Typography>
        </div>
    );
};

export default SnackbarErrorMsg;
